export default "__VITE_ASSET__C2LpV4m4__"